import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=2fbc429e&scoped=true"
import script from "./pay.vue?vue&type=script&lang=js"
export * from "./pay.vue?vue&type=script&lang=js"
import style0 from "../../style/common-m.scss?vue&type=style&index=0&id=2fbc429e&prod&lang=scss&scoped=true&external"
import style1 from "./pay.vue?vue&type=style&index=1&id=2fbc429e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../content-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbc429e",
  null
  
)

export default component.exports